const colorLimit = () => {

    $(document).ready(() => {
        var colorWrapper = $('.list-colors-wrapper');
        colorWrapper.each(function(){
            var colorNum = $(this).find('.list-item-color');
            if (colorNum.length > 4) {
                $(this).addClass('overColor');
            }
        })
    })
        
};

export {
    colorLimit
};
